import { hasFeatureAccess } from '@utils'
import { useUserProfileQry } from 'mmfintech-backend-api'
import { type FeatureConfig, featuresConfig } from '../features-config'

type FeatureName = keyof typeof featuresConfig

export const useFeatureFlag = (featureName: FeatureName): boolean => {
  const { profile } = useUserProfileQry()

  const featureConfig: FeatureConfig = featuresConfig[featureName]

  return hasFeatureAccess(featureConfig, profile?.email)
}
